import styled from 'styled-components';

export const DeleteGstModal = styled.div`
  padding: 24px;
  .mdlHeading {
    font-size: 22px;
    line-height: 28px;
    font-weight: 900;
    margin-left: 6px;
  }
  .mdlSubHeading {
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
  }
`;

export const DeleteGstCard = styled.div(
  props => `
        background:${props.background};
        border-radius:12px;
        padding:12px 16px;
        margin-top:12px;
        .cardHeading{
            font-size:14px;
            line-height:20px;
            font-weight:700;
            color:#4a4a4a;
        }
        .cardTag{
            padding:2px 8px;
            border-radius:14px;
            border:1px solid #d8d8d8;
            color:#757575;
            font-weight:700;
            text-transform:uppercase;
            margin-left:8px;
        }
        .cardSubHeading{
            font-size:12px;
            line-height:16px;
            color:#4a4a4a;
            margin-top:4px;
        }
        .cardSubHeadingTwo{
            font-size:12px;
            line-height:16px;
            color:#4a4a4a;
            margin-top:8px;
        }
    `,
);

export const mdlCtaWrap = styled.div(
  props => `
        display:flex;
        align-items:center;
        justify-content:center;
        margin-top:8px;
    `,
);

export const ctaItem = styled.span(
  props => `
        color:${props.color};
        padding:10px 16px;
        margin:${props.margin};
        text-transform:uppercase;
        font-size:16px;
        line-height:24px;
        font-weight:900;
        cursor:pointer;
    `,
);
